import state from "../store/index";

const DetectionMethods = [
  { id: 0, name: state.getters["page/strings"].equipListeningStick },
  { id: 1, name: state.getters["page/strings"].equipGroupMicrophone },
  { id: 2, name: state.getters["page/strings"].equipLiveCorrelatorAccel },
  { id: 3, name: state.getters["page/strings"].equipLiveCorrelatorHydro },
  { id: 4, name: state.getters["page/strings"].equipLiftAndShiftCor },
  { id: 5, name: state.getters["page/strings"].equipLiftAndShiftNoise },
  { id: 6, name: state.getters["page/strings"].equipHydrogenGas },
  { id: 7, name: state.getters["page/strings"].other }
];

export { DetectionMethods };
